import './assets/css/success.scss'
import Lottie from 'react-lottie';
import loadingAnimation from '../../assets/images/loading.json'
import {NavLink, useNavigate, useParams} from "react-router-dom";
import useCountDown from "../../utility/useCountDown";
import {useEffect, useState} from "react";
import AppCartController from "../Main/controller/AppCartController";
import AppSettingController from "../Main/controller/AppSettingController";
import MarketSetting from "../Main/interface/MarketSettingLocalStorage";
import {useTranslation} from "react-i18next";
import {withLang} from "../../routes/LangLayout";

export default function Success() {
    const {t} = useTranslation();
    const setting = AppSettingController.getSetting() as MarketSetting;
    const count = useCountDown(13);
    const navigate = useNavigate();
    const {shopId, lang} = useParams();
    const textSuccessWithPos = t("success.posSuccess");
    const textSuccessWithCash = t("success.cashSuccess");
    const [title, setTitle] = useState(textSuccessWithPos)
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: loadingAnimation,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    useEffect(() => {
        if (!count) {
            navigate(withLang(`/${shopId}`, lang), {replace: true});
        }
    }, [count, lang, navigate, shopId]);

    useEffect(() => {
        if (AppSettingController.isActivePayment())
            setTitle(textSuccessWithCash)
        if (setting.marketMode === 'pos-or-cash')
            setTitle(setting.paymentMode === 'pos' ? textSuccessWithPos : textSuccessWithCash)
    }, [textSuccessWithCash, textSuccessWithPos, setting.marketMode, setting.paymentMode]);

    return (
        <section className={'success-container'}>
            <div className={'content'}>
                <div className="logo">
                    <Lottie
                        options={defaultOptions}
                        isClickToPauseDisabled
                        height={120}
                        width={120}
                    />
                </div>
                <div className={'title'}>
                    <h1>{title}</h1>
                    <p>{t("success.takeReceipt")}</p>
                </div>
                <div className="footer">
                    <NavLink to={withLang(`/${shopId}`, lang)} onClick={() => AppCartController.clearCart()}>{t("back")}</NavLink>
                    <p>{t("success.autoRedirect", { count })}</p>
                </div>
            </div>
        </section>
    )
}
